import React, { useCallback, useEffect } from 'react';
import styles from './Services.module.css';

import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Separator from '../../components/Separator';

import servicesJson from '../../assets/data/services.json';

const Services = () => {
    const { t, i18n } = useTranslation();
    const { hash } = useLocation();

    const serviceTitleContainer = service => (
        <div className={styles.serviceTitleContainer}>
            <img
                className={styles.serviceImg}
                src={service.img}
                alt={service.title[i18n.language]}
            />
            <p className={styles.serviceTitle}>{service.title[i18n.language]}</p>
        </div>
    );

    const serviceDescriptionContainer = service => (
        <div className={styles.serviceDescriptionContainer}>
            <div
                className={styles.serviceDescription}
                dangerouslySetInnerHTML={{ __html: service.description[i18n.language] }}
            />
            {service.id === 'gdpr' && (
                <Link to='/services/gdpr' className={styles.gdprBtn}>
                    {t('moreBtn')}
                </Link>
            )}
        </div>
    );

    const checkNScrollToService = useCallback(() => {
        if (hash) {
            const yOffset = -100;
            const y =
                document.getElementById(hash.substring(1)).getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }, [hash]);

    useEffect(() => {
        document.title = 'Services - The Records Hub S.A.';
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className={styles.mainContainer} onLoad={checkNScrollToService}>
            <div className={styles.titleContainer}>
                <p className={styles.title}>{t('services.title')}</p>
                <Separator widht={'15px'} height={'1px'} color={'#f7931d'} margin={`30px 0 0 0`} />
            </div>
            <div className={styles.servicesContainer}>
                {servicesJson &&
                    servicesJson.map((service, i) => (
                        <div
                            key={`service_${i}`}
                            id={service.id}
                            className={styles.serviceContainer}
                            style={{
                                backgroundColor: i % 2 === 0 ? '#FCFCFC' : 'white',
                                flexDirection: i % 2 === 0 ? 'row ' : 'row-reverse '
                            }}
                        >
                            <>
                                {serviceTitleContainer(service)}
                                {serviceDescriptionContainer(service)}
                            </>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default Services;
